export default function($form) {
  let extForm = $form.getExtForm();
  let businessId=extForm.businessId;
  let taskId=extForm.taskId;
  PF.show('transactionProcess',{businessId:businessId, batchId:extForm.batchId, taskId:taskId});
}



// WEBPACK FOOTER //
// ./src/common/components/extend/form/src/config/flow-transaction-dialog.js